import PropTypes from 'prop-types'
import React from 'react'

import assetsPath from '../../../common/utils/assetsPath'
import headerLayoutConfig from '../../../config/layout/header'
import HeaderEnvatoProducts from './header/envatoProducts'
import HeaderAdminLink from './header/adminLink'
import HeaderCart from './header/cart'
import HeaderUserMenu from './header/userMenu'

class GlobalHeader extends React.Component {
  static propTypes = {
    currentSite: PropTypes.string.isRequired,
    user: PropTypes.object
  }

  render () {
    const { staticLinks, envatoProducts, envatoProductsStaticLinks } = headerLayoutConfig
    const { user, currentSite } = this.props

    return (
      <div className='global-header fds-u-hide-extra-large-and-below'>
        <div className='grid-container -layout-wide'>
          <div className='global-header__wrapper'>
            <a href='https://market.envato.com'>
              <img className='global-header__logo'
                alt='Envato Market'
                src={`${assetsPath()}/images/logo-envato-market.svg`} />
            </a>

            <nav className='global-header-menu' role='navigation'>
              <ul className='global-header-menu__list'>
                <HeaderAdminLink user={user} />

                {
                  staticLinks.map((staticLink) => {
                    return (
                      <li key={staticLink.label}
                        className='global-header-menu__list-item'>
                        <a href={staticLink.url}
                          className='global-header-menu__link'>
                          <span className='global-header-menu__link-text'>
                            {staticLink.label}
                          </span>
                        </a>
                      </li>
                    )
                  })
                }

                <HeaderEnvatoProducts envatoProducts={envatoProducts} envatoProductsStaticLinks={envatoProductsStaticLinks} />

                <HeaderCart user={user} />

                <HeaderUserMenu
                  user={user}
                  currentSite={currentSite}
                />
              </ul>
            </nav>
          </div>
        </div>
      </div>
    )
  }
}

export default GlobalHeader



// WEBPACK FOOTER //
// ./client/components/siteHeader/globalHeader.js